import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_BEGIN,
  DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_SUCCESS,
  DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_FAILURE,
  DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function loadPermissionFlags(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_BEGIN,
    });
    const { projectId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`${process.env.REACT_APP_BUILDER_ENGINE}permissions/get`, header);

      doRequest.then(
        (res) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPermissionFlagsError() {
  return {
    type: DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_BEGIN:
      return {
        ...state,
        loadPermissionFlagsPending: true,
        loadPermissionFlagsError: null,
      };

    case DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_SUCCESS:
      return {
        ...state,
        loadPermissionFlagsPending: false,
        loadPermissionFlagsError: null,
        permissionFlags: action.data,
      };

    case DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_FAILURE:
      return {
        ...state,
        loadPermissionFlagsPending: false,
        loadPermissionFlagsError: action.data.error,
      };

    case DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_DISMISS_ERROR:
      return {
        ...state,
        loadPermissionFlagsError: null,
      };

    default:
      return state;
  }
}
